import { IoAddCircleOutline } from "react-icons/io5";
import { MdBlock, MdOutlineDelete, MdOutlineModeEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import "./Button.css";
import { forwardRef } from "react";
import { UserPlus, Save } from "lucide-react";
import { FaRegCircleCheck, FaRegCirclePlay } from "react-icons/fa6";
import { Loading } from "../../icons/loading";
import { GoCheckCircle } from "react-icons/go";
import { useTranslation } from "react-i18next";

const Button = forwardRef(({ status = null, iconPosition = "left", isLoading = false, ...props }, ref) => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	const handleClick = () => {
		if (props.navigate) navigate(props.navigate, { replace: true });

		if (props.onClick) props.onClick();
	};

	function getIconContent() {
		return (
			<div style={{ display: "flex", marginLeft: props.label ? "-3px" : 0 }}>
				{props.action === "add" && <IoAddCircleOutline size={22} />}
				{props.action === "addUser" && <UserPlus size={17} />}
				{props.action === "edit" && <MdOutlineModeEdit size={18} />}
				{props.action?.includes("delete") && <MdOutlineDelete size={18} />}
				{props.action?.includes("confirm") && <FaRegCircleCheck size={18} />}
				{props.icon && props.icon}
			</div>
		);
	}

	return (
		!props.hidden && (
			<button
				{...props}
				className={`
					${(props.className || "") + (props.action === 'delete' ? " button-red" : "") + " button-blue"}
					${(isLoading || status) ? 'pointer-events-none relative' : ''}
					${status ? `${status === 'error' ? 'bg-red-500/80! border-red-500/80! *:text-white!' : 'bg-green-500! border-green-500/80! *:text-white!'}` : ``}
					duration-700
				`}
				onClick={(e) => { e.stopPropagation(); handleClick(); }}
				type={props.type || "button"}
				disabled={props.disabled || isLoading}
				ref={ref}
				style={props.disabled || isLoading ? { opacity: 0.5, cursor: "not-allowed" } : { ...props.style }}
			>
				<div className={`relative z-10 button-container ${(isLoading || status) ? 'opacity-0' : ''}`}>
					{(props.action || props.icon) && iconPosition === "left" ?
						getIconContent()
						: (
							<>
								{(props.label?.toLowerCase().includes('salv') || props.label?.toLowerCase().includes('guardar')) && <Save size={18} />}
								{props.label?.toLowerCase().includes('confirm') && <FaRegCircleCheck size={18} />}
								{props.label?.toLowerCase().includes('execut') && <FaRegCirclePlay size={18} />}
							</>
						)}
					<span className={"button-span"}>{props.label}</span>
					{(props.action || props.icon) && iconPosition === "right" ? getIconContent() : null}
				</div>
				{isLoading && (
					<Loading className={`absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 size-6 z-20`} />
				)}
				<span className={`absolute z-20 inline-flex items-center gap-1 duration-500 ${status === 'error' ? '' : 'opacity-0'}`}>
					<MdBlock size={18} />
					{props.errorLabel ?? t("common.error")}
				</span>
				<span className={`absolute z-20 inline-flex items-center gap-1 duration-500 ${status === 'success' ? '' : 'opacity-0'}`}>
					<GoCheckCircle size={18} />
					{props.successLabel ?? t("common.success")}
				</span>
			</button>
		)
	);
});

export default Button;
